var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-table-cell-wrap",attrs:{"title":_vm.displayTitle}},[(_vm.isHtml)?_c('span',{staticClass:"main-table-txt",domProps:{"innerHTML":_vm._s(_vm.displayValue)}}):_c('span',{staticClass:"main-table-txt",domProps:{"textContent":_vm._s(_vm.displayValue)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3daad6f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/grid-table-cell.vue
// module id = null
// module chunks = 